import React, {Component} from 'react'
import {Col, Row, CardHeader, CardBody, Button, Table, ButtonGroup} from 'reactstrap'
import ReactPaginate from 'react-paginate'
import queryString from 'query-string'
import PropTypes from 'prop-types'
import {PeopleListFetchQuery, changeUserAccessMutation, anonymizePersonMutation} from './mutations'
import {graphql, compose} from 'react-apollo'
import {UnmountClosed, Collapse} from 'react-collapse'
import Form from './Form'
import UserForm from './UserForm'
import {getUserPermissions} from '../../utils/userPermissions'
import 'react-block-ui/style.css'
import PeopleFilter from './PeopleFilter'
import BlockWithLoader from '../Support/BlockWithLoader'
import _ from 'lodash'
import {API_BASE_URL} from '../../utils/apiConfig'
import ConfirmModal from '../Alerts/ConfirmModal'
import {Link} from 'react-router-dom'

function prepareFiltersFromUrl(search) {
  return _.omit(queryString.parse(search), 'page', 'size', '')
}

class PeopleList extends Component {

  constructor(props) {
    super(props)
    const parsed_search = queryString.parse(this.props.location.search)
    this.state = {
      people_list: [],
      page_count: 0,
      form_is_opened: false,
      user_form: false,
      data_to_edit: {},
      user_data_to_edit: {},
      page: Number(parsed_search.page) || 1,
      per_page: Number(parsed_search.size) || 10,
      filter_form: false,
      filters: {},
      personIdAnonymize: null
    }

    this.clearEditData = this.clearEditData.bind(this)

    this.handleFilterFormToggle = this.handleFilterFormToggle.bind(this)
    this.runFilterPeople = this.runFilterPeople.bind(this)
    this.updateFiltersData = this.updateFiltersData.bind(this)
  }

  static propTypes = {
    location: PropTypes.object.isRequired,
    data: PropTypes.object.isRequired,
    history: PropTypes.object.isRequired,
    changeUserAccessMutation: PropTypes.func.isRequired,
    anonymizePersonMutation: PropTypes.func.isRequired
  }

  componentWillReceiveProps(nextProps) {
    if (this.props.data.loading === false && nextProps.data.loading === false && nextProps.history.action === 'PUSH') {
      this.props.data.refetch()
    }

    if (nextProps.data.loading === false && nextProps.data.people) {
      let people = nextProps.data.people.list.slice(0) //clone
      this.setState({
        people_list: people,
        page_count: nextProps.data.people.metadata.total_pages,
        page: Number(queryString.parse(nextProps.location.search).page) || 1,
        filters: prepareFiltersFromUrl(nextProps.location.search)
      })
    }
  }

  handlePageClick = (data) => {
    if (this.state.page !== data.selected + 1) {
      this.handleFilterInUrl(data.selected + 1)
    }
  }

  clearEditData() {
    this.setState({data_to_edit: {}, user_data_to_edit: {}})
  }

  handleFilterFormToggle() {
    this.setState({filter_form: !this.state.filter_form})
  }

  runFilterPeople() {
    this.handleFilterInUrl(1)
  }

  handleFilterInUrl(page) {
    let newFilter = {...this.state.filters}
    this.props.history.push(`${this.props.history.location.pathname}?${`page=${page}&`}${queryString.stringify(newFilter)}`)
  }

  updateFiltersData(new_filters) {
    this.setState({filters: {...this.state.filters, ...new_filters}})
  }

  renderList() {
    return this.state.people_list.map(person => (
      <tr className='tr-render-list' key={person.id} onClick={() => this.props.history.push(`/people/${person.id}`)}>
        <td>{person.photo && <img alt='profile_photo' src={API_BASE_URL + person.photo.thumb_url}/>}</td>
        <td>
          <b>{person.uuid}</b>
        </td>
        <td>
          {`${person.first_name} ${person.last_name}`}
        </td>
        <td>{person.phone}</td>
        <td>
          <b>
            {person.group_ids && person.group_ids.map(group_id => this.props.data.groups.find(o => o.id === group_id).name).join(', ')}
          </b>
        </td>
        <td>
          {person.company_ids && person.company_ids.map(company_id => this.props.data.companies.list.find(o => o.id === company_id).name).join(', ')}
        </td>
        <td>{person.active ? <i className="fa fa-check fa-lg"/> : <i className="fa fa-close fa-lg"/>}</td>
        <td>{person.user && person.user.email}</td>
        <td>{person.user ? (person.user.locked ? <i className="fa fa-lock fa-lg"/> :
          <i className="fa fa-check fa-lg"/>) : <i className="fa fa-close fa-lg"/>}</td>
        <td>
          <ButtonGroup size="sm">
            {
              !person.anonymized_at && [
                getUserPermissions('core.people.update') && !this.state.form_is_opened &&
                <Button key='edit' id="edit-person-btn" color="warning" className="float-right" title="Edit" onClick={(e) => {
                  e.stopPropagation()
                  this.setState({form_is_opened: true, data_to_edit: person})
                }
                }>
                  <i className="fa fa-edit"/>
                </Button>,
                getUserPermissions('core.people.anonymize') &&
                <Button key='anonymize' id="edit-person-btn" color="warning" className="float-right" title="Anonymize" onClick={(e) => {
                  e.stopPropagation()
                  this.setState({personIdAnonymize: person.id})
                }}>
                  <i className="fa fa-user-secret"/>
                </Button>,
                person.user && getUserPermissions('core.users.update') &&
                <Button key='user-lock' id="change-user-access-btn" color="secondary" className="float-right" title="User access"
                  onClick={(e) => {
                    e.stopPropagation()
                    this.props.changeUserAccessMutation({
                      variables: {user_id: Number(person.user.id)}
                    }).then(() => {
                    })
                  }}>
                  <i className="fa fa-lock fa-lg"/>
                </Button>,
                ((person.user && getUserPermissions('core.users.update')) || (!person.user && getUserPermissions('core.users.create'))) &&
                <Button key='edit-or-add-user' id="edit-add-user-btn" color="secondary" className="float-right" title="User" onClick={(e) => {
                  e.stopPropagation()
                  this.setState({
                    user_form: person.id,
                    user_data_to_edit: person.user || {}
                  })
                }}>
                  <i className="fa fa-user-o"/>
                </Button>
              ]
            }
          </ButtonGroup>
        </td>
      </tr>
    ))
  }

  render() {
    if (this.props.data.error) {
      return (<div>An unexpected error occurred</div>)
    }

    return (
      <BlockWithLoader loading={this.props.data.loading} renderChildren={true}>
        <UnmountClosed isOpened={this.state.form_is_opened}>
          <CardHeader><b>{this.state.data_to_edit.id ? `Person id: ${this.state.data_to_edit.id}` : 'Add new person'}</b>
            {this.state.data_to_edit.uuid &&
            <Link className='float-right' role='button' to={`/welders?uuid=${this.state.data_to_edit.uuid}`} target='_blank'>
              <Button size='sm' color='primary'>Their certificates</Button>
            </Link>}
          </CardHeader>
          <Form
            onClose={() => this.setState({form_is_opened: false})}
            afterSubmit={() => this.setState({form_is_opened: false})}
            editData={this.state.data_to_edit}
            clearFunction={this.clearEditData}
            permissionGroupsData={this.props.data.groups}
            companiesData={this.props.data.companies && this.props.data.companies.list}
          />
        </UnmountClosed>
        <UnmountClosed isOpened={!!this.state.user_form}>
          <CardHeader>{this.state.user_data_to_edit.id ? 'Edit User' : 'Add new User'}</CardHeader>
          <UserForm formToggleFunction={() => this.setState({user_form: false})}
            editData={this.state.user_data_to_edit}
            clearFunction={this.clearEditData}
            person_id={Number(this.state.user_form)}
          />
        </UnmountClosed>
        <ConfirmModal
          isOpened={!!this.state.personIdAnonymize}
          onCancel={() => this.setState({personIdAnonymize: null})}
          onConfirm={() =>
            this.props.anonymizePersonMutation({variables: {person_id: this.state.personIdAnonymize}})
              .then(() => {this.setState({personIdAnonymize: null})})
          }
          headerText='Anonymize Person'
          bodyText='Are you sure you want to anonymize data and lock user for this person?'
          confirmBtnText='Anonymize'
        />
        <CardHeader>
          <b>People</b>
          {!this.state.form_is_opened && !this.state.user_form && getUserPermissions('core.people.create') &&
          <Button color="primary" id="add-new-person-btn"
            className="float-right btn-element"
            onClick={() => {
              this.setState({form_is_opened: true})
            }}
          >
            <i className="fa fa-plus"/> Add new person
          </Button>}
          {!this.state.form_is_opened && !this.state.user_form && (getUserPermissions('core.groups.create') ||
            getUserPermissions('core.groups.update')) &&
          <Button color="success" id="go-to-people-groups"
            className="float-right btn-element"
            onClick={() => {
              this.props.history.push('/people/groups')
            }}
          >
            <i className="fa fa-id-card-o"/> Manage groups
          </Button>}
          <Button id="open-filter-btn"
            className="float-right btn-add-project"
            onClick={() => {
              this.setState({filter_form: !this.state.filter_form})
            }}
          >
            <i className="fa fa-filter"/> Filter
          </Button>
        </CardHeader>
        <Collapse isOpened={this.state.filter_form}>
          <PeopleFilter
            groupsList={this.props.data.groups}
            companyList={this.props.data.companies && this.props.data.companies.list}
            formToggleFunction={this.handleFilterFormToggle}
            submitFunction={this.runFilterPeople}
            updateFiltersFunction={this.updateFiltersData}
            filtersData={this.state.filters}
            clearFiltersDataFunction={() => this.setState({filters: {}}, () => this.runFilterPeople())}
          />
        </Collapse>

        <CardBody>
          <Row>
            <Col md="12">
              <Table hover responsive className="table-project">
                <thead>
                  <tr>
                    <th/>
                    <th style={{width: '60px'}}>UUID</th>
                    <th>Name</th>
                    <th>Phone</th>
                    <th>Groups</th>
                    <th>Companies</th>
                    <th>Active</th>
                    <th>Email</th>
                    <th>User</th>
                    <th style={{width: '130px'}}>Actions</th>
                  </tr>
                </thead>
                <tbody>
                  {this.renderList()}
                </tbody>
              </Table>
            </Col>
          </Row>
        </CardBody>

        {this.state.page_count > 1 &&
        <Col className="text-center">
          <ReactPaginate
            forcePage={this.state.page - 1}
            previousLabel={'Prev'}
            nextLabel={'Next'}
            breakLabel={<a href="">...</a>}
            breakClassName={'break-me'}
            pageCount={this.state.page_count}
            marginPagesDisplayed={2}
            pageRangeDisplayed={5}
            onPageChange={this.handlePageClick}
            containerClassName={'pagination justify-content-center'}
            subContainerClassName={'pages pagination'}
            activeClassName={'active'}
          />
        </Col>}
      </BlockWithLoader>
    )
  }
}

const PeopleListWithData = compose(
  graphql(PeopleListFetchQuery,
    {
      options: (props) => ({
        fetchPolicy: 'network-only',
        variables: {
          page: Number(queryString.parse(props.location.search).page) || 1,
          filters: prepareFiltersFromUrl(props.location.search)
        }
      }),
    },
  ),
  graphql(changeUserAccessMutation, {name: 'changeUserAccessMutation'}),
  graphql(anonymizePersonMutation, {name: 'anonymizePersonMutation'})
)(PeopleList)

export default PeopleListWithData



// WEBPACK FOOTER //
// ./src/components/People/PeopleList.js